/* eslint-disable */
import { Phone } from 'lucide-react';
const list = [
    {
        "id": 1,
        "title": "For urgent support on UY App, UY Console & UY AI Devices, please call on 9958863566, for all issues please send email on support@udyogyantra.com",
    }
];

const marqueeKeyframes = `
@keyframes marquee {
    0% { transform: translateX(100vw); }
    100% { transform: translateX(-100%); }
}
`;

export function Banner() {
    return (
        <>
            <style>{marqueeKeyframes}</style>
            <div
                style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    backgroundColor: '#FEF3C7',
                    borderBottom: '1px solid #F59E0B',
                    padding: '6px 0',
                }}
            >
                <div
                    style={{
                        display: 'inline-flex',
                        gap: '4rem',
                        animation: 'marquee 25s linear infinite',
                    }}
                >
                    {list.map((item) => (
                        <span
                            key={item.id}
                            style={{
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#92400E',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                            }}
                        >
                            <Phone size={14} />
                            {item.title}
                        </span>
                    ))}
                </div>
            </div>
        </>
    );
}